<section class="ack-card">
  <h2 class="ack-title">Enrollments Awaiting Acknowledgement</h2>

  <div class="ack-scroll">
    <div *ngIf="loading" class="flex items-center justify-center py-10">
      <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    </div>

    <p *ngIf="!loading && items.length === 0" class="ack-empty">
      {{ emptyMessage }}
    </p>

    <ul *ngIf="!loading && items.length > 0" class="ack-list">
      <li *ngFor="let item of items" class="ack-row">
        <span class="status-dot" aria-hidden="true"></span>
        <div class="ack-body">
          <div class="client-name">{{ item.clientName }}</div>
          <div class="ack-meta">{{ pendingLabel(item.pendingCount) }}</div>
        </div>
        <a class="contact-link" [routerLink]="['/clients', item.mCode, 'subclients', item.cCode, 'contacts']">Contact</a>
      </li>
    </ul>
  </div>

  <p *ngIf="!loading && items.length > 0" class="ack-caption">
    Client must acknowledge in the client portal to confirm payroll deductions.
  </p>
</section>
